{
    "Accessibility menu": "అందుబాటు మెనూ",
    "Close": "మూసివేయండి",
    "Content adjustments": "విషయ సర్దుబాట్లు",
    "Navigation adjustments": "నావిగేషన్ సర్దుబాట్లు",
    "Text Align": "టెక్స్ట్ అమరిక",
    "Align Left": "ఎడమవైపు సమలేఖనం చేయి",
    "Align Center": "మధ్యలో సమలేఖనం చేయి",
    "Align Right": "కుడివైపు సమలేఖనం చేయి",
    "Adjust Font Size": "ఫాంట్ పరిమాణాన్ని సర్దుబాటు చేయండి",
    "Highlight Title": "శీర్షికను హైలైట్ చేయండి",
    "Highlight Links": "లింక్‌లను హైలైట్ చేయండి",
    "Readable Font": "చదవగలిగే ఫాంట్",
    "Colour adjustments": "రంగు సర్దుబాట్లు",
    "Dark Contrast": "చీకటి వ్యత్యాసం",
    "Light Contrast": "తేలిక వ్యత్యాసం",
    "High Contrast": "ఎక్కువ వ్యత్యాసం",
    "High Saturation": "ఎక్కువ సంతృప్తి",
    "Low Saturation": "తక్కువ సంతృప్తి",
    "Monochrome": "ఏకరంగు",
    "Tools": "సాధనాలు",
    "Reading Guide": "పఠన మార్గదర్శి",
    "Big Cursor": "పెద్ద కర్సర్",
    "Increase Font Size": "ఫాంట్ పరిమాణాన్ని పెంచండి",
    "Decrease Font Size": "ఫాంట్ పరిమాణాన్ని తగ్గించండి",
    "Letter Spacing": "అక్షరాల మధ్య ఖాళీ",
    "Line Height": "పంక్తి ఎత్తు",
    "Font Weight": "ఫాంట్ బరువు",
    "Dyslexia Font": "డిస్లెక్సియా ఫాంట్",
    "Language": "భాష",
    "Accessibility widget": "అందుబాటు మెనూని తెరవండి",
    "Accessibility Profiles": "అందుబాటు ప్రొఫైల్‌లు",
    "Cognitive Disability": "జ్ఞాన సంబంధిత వైకల్యం",
    "Seizure Safe": "పట్టు సురక్షితం",
    "Accessibility statement": "అందుబాటు ప్రకటన",
    "ADHD": "ADHD",
    "Low Vision": "తక్కువ దృష్టి",
    "Pause Animations": "యానిమేషన్‌లను ఆపండి",
    "Animation paused": "యానిమేషన్ పాజ్ చేయబడింది",
    "Reset all settings": "సెట్టింగ్‌లను రీసెట్ చేయండి",
    "Shortcut:": "షార్ట్‌కట్:",
    "Epilepsy Safe Mode": "మూర్ఛ సురక్షిత మోడ్",
    "Mute sounds": "శబ్దాలను మ్యూట్ చేయి",
    "Page read": "పేజీని చదవండి",
    "Page read controls": "పేజీ చదివే నియంత్రణలు",
    "Pause": "నిలిపివేయి",
    "Resume": "తిరిగి ప్రారంభించు",
    "Stop": "ఆపు",
    "Settings": "సెట్టింగ్‌లు",
    "Speed": "వేగం",
    "Voice": "వాయిస్",
    "Close accessibility menu": "యాక్సెసిబిలిటీ మెనూను మూసివేయి",
    "Back to accessibility menu": "యాక్సెసిబిలిటీ మెనూకు తిరిగి వెళ్లు",
    "Search languages": "భాషలను శోధించు",
    "Selected language": "ఎంచుకున్న భాష",
    "View accessibility statement (opens in new window)": "యాక్సెసిబిలిటీ ప్రకటనను చూడండి (కొత్త విండోలో తెరుచుకుంటుంది)",
    "Visit CookieYes website (opens in new window)": "CookieYes వెబ్‌సైట్‌ను సందర్శించండి (కొత్త విండోలో తెరుచుకుంటుంది)",
    "Reset all accessibility settings to default": "అన్ని యాక్సెసిబిలిటీ సెట్టింగ్‌లను డిఫాల్ట్‌కు రీసెట్ చేయి"
}
